import React, {
    createContext,
    PropsWithChildren,
    useRef,
} from 'react';
import { acquisitionReducer, initialAcquisitionState } from './reducer';
import { IAcquisitionStore, TAcquisitionState } from './types';

export const AcquisitionStoreContext = createContext<IAcquisitionStore | undefined>(undefined);

export const ModernAcquisitionProvider = ({ children }: PropsWithChildren<{}>) => {

    const listenerRef = useRef<Set<() => void>>(new Set())
    const acquisitionState = useRef<TAcquisitionState>(initialAcquisitionState);
    const acquisitionStore = useRef<IAcquisitionStore>({
        getState: () => acquisitionState.current,
        dispatch: (action) => {
            const prevState = acquisitionState.current;
            const newState = acquisitionReducer(acquisitionState.current, action);

            /**
             * acquisitionReducer will produce a shallow copy of the first level.
             * Require each listener to determine if its corresponding field
             * contains an update or not.
             */
            if (newState !== prevState) {
                acquisitionState.current = newState;
                listenerRef.current.forEach((listener) => {
                    listener();
                });
            }
        },
        subscribe: (listener) => {
            listenerRef.current.add(listener)
            return () => {
                listenerRef.current.delete(listener)
            };
        },
        getStateCopy: () => JSON.parse(JSON.stringify(acquisitionState.current))
    });

    return (
        <AcquisitionStoreContext.Provider value={acquisitionStore.current}>
            {children}
        </AcquisitionStoreContext.Provider>
    )
}